module.exports = __webpack_public_path__ + "static/media/comment-alt-music.db932cb3.svg";